import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { closeLinkModal, linkModalSelector } from 'store/modals'
import ConfirmModal from 'ui/components/ConfirmModal'
import ModalBasic from 'ui/components/ModalBasic'
import Gantt from './components/Gantt'
import Wiki from './components/Wiki'
import { MODE } from './constants'

const ModalLink = () => {
  const dispatch = useDispatch()
  const [confirmOpened, setConfirmOpened] = useState(false)
  const { open, title, type } = useSelector(linkModalSelector)

  const isWikiMode = type === MODE.WIKI
  const isGanttMode = type === MODE.GANTT

  const handlerClose = () => {
    dispatch(closeLinkModal())
    setConfirmOpened(false)
  }

  return (
    <>
      <ModalBasic
        size={'small'}
        open={open}
        handlerClose={() => setConfirmOpened(true)}
        title={title}
        onRouteChangeClose={() => {
          dispatch(closeLinkModal())
        }}
      >
        {isWikiMode && <Wiki />}
        {isGanttMode && <Gantt />}
        <ConfirmModal
          title="Закрыть окно?"
          open={confirmOpened}
          confirmHandler={handlerClose}
          handlerClose={() => setConfirmOpened(false)}
        />
      </ModalBasic>
    </>
  )
}

export default ModalLink
